 import React , {useState} from "react";
import NavBar from "./../components/NavBar";
import SideBar from "./../components/SideBar";
import { Outlet } from 'react-router-dom';
import SettingDrawer from "./../components/SettingDrawer";

const StudentLayout = ({setSideBar,show_sidebar,show_settingdrawer,setSettingDrawer})=>{
    return (
<>
 <SideBar show_sidebar={show_sidebar} setSideBar={setSideBar} />
      <SettingDrawer show_settingdrawer={show_settingdrawer} setSettingDrawer={setSettingDrawer} />

      <div style={{ paddingBottom: '60px' }}> {/* Give space for fixed NavBar if needed */}
        <Outlet />
      </div>

      <NavBar setSideBar={setSideBar} />
</>
    );
}
export default StudentLayout;